import { removeRadiusState } from '../radius';

/**
 * @param {MapSearch} ctx - the map search context
 */
async function removeRadius( ctx ) {
    ctx.setLoading( true );

    ctx.locationIndicator.clear();

    removeRadiusState( ctx.map );

    const propertyParams = new URLSearchParams( ctx.previousSearchState );

    propertyParams.delete( 'radius' );

    const updateParams = {
        fetchFeatures: false,
        fetchProperties: true,
        propertySearchURL: ctx.propertySearchURL,
        propertySearchParams: propertyParams,
    };

    ctx.previousSearchState = propertyParams.toString();

    await ctx.update( updateParams );

    ctx.setLoading( false );
}

export {
    removeRadius,
};
